import React, { useEffect, useState } from 'react';

export const Timer = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format time parts separately to prevent layout shift
  const getTimeParts = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return {
      hours: String(displayHours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
      ampm: ampm,
    };
  };

  // Format date as "Sat, Jun 22"
  const formatDate = (date) => {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dayName = dayNames[date.getDay()];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    return `${dayName}, ${month} ${day}`;
  };

  const timeParts = getTimeParts(currentTime);

  return (
    <div className="h-38 box-border sm:min-w-190 hidden sm:flex items-center justify-between px-2 border-solid border border-tertiary rounded-full  text-sm leading-5 text-inactive-text whitespace-nowrap font-normal">
      <p className=" text-sm leading-5 text-inactive-text whitespace-nowrap font-normal m-0 flex items-center">
        <span className="inline-block w-4 text-center">{timeParts.hours}</span>{' '}
        <span>:</span>
        <span className="inline-block w-4 text-center">
          {timeParts.minutes}
        </span>{' '}
        <span> :</span>
        <span className="inline-block w-4 text-center">
          {timeParts.seconds}
        </span>
        <span className="inline-block w-6 text-left ml-1">
          {timeParts.ampm}
        </span>
      </p>
      <div className="w-1 h-1 rounded-full bg-inactive-text shrink-0" />
      <p className=" text-sm leading-5 text-inactive-text whitespace-nowrap font-normal m-0">
        {formatDate(currentTime)}
      </p>
    </div>
  );
};
